{
  "active": "Actif",
  "inactive": "Inactif",
  "loading": "Chargement",
  "logout": "Déconnexion",
  "save": "Enregistrer",
  "edit": "Modifier",
  "cancel": "Annuler",
  "retry": "Réessayer",
  "add": "Ajouter",
  "import": "Importer",
  "error": "Une erreur est survenue",
  "back": "Retour",
  "yes": "Oui",
  "no": "Non",
  "true": "Oui",
  "false": "Non",
  "from": "De",
  "to": "A",
  "cpm": "CPM",
  "new": "Nouveau",
  "delete": "Supprimer",
  "confirm?": "Êtes-vous sûr ?",
  "irreversible": "Cette action est définitive",
  "irreversible_with_name": "Cette action est définitive, saisissez \"{{name}}\" pour supprimer",
  "locations": "Localisations",
  "visits": "Visites",
  "traces": "Origine / Destinations",
  "geovisits": "Visites géocodées",
  "wifi_events": "Évènements wifi",
  "beacons": "Beacons",
  "snapped_traces": "Traces Snappées",
  "geocodedVisits": "Visites géocodées",
  "sync": "Synchroniser",
  "pleaseSelect": "Sélectionner...",
  "reset_password": "Réinitialiser le mot de passe",
  "resend_confirmation_instructions": "Renvoyer les instructions de confirmation",
  "or": "ou",
  "remove": "supprimer",
  "ios": "iOS",
  "android": "Android",
  "countries": {
    "fr": "France",
    "gb": "Royaume-Uni",
    "it": "Italie",
    "be": "Belgique",
    "lu": "Luxembourg",
    "pt": "Portugal",
    "ch": "Suisse",
    "de": "Allemagne",
    "es": "Espagne",
    "nl": "Pays-Bas",
    "ie": "Irlande"
  },
  "languages": {
    "fr": "Français",
    "en": "Anglais"
  },
  "latitude": "Latitude",
  "longitude": "Longitude",
  "radius": "Rayon",
  "preview": "Aperçu",
  "none": "Aucun",
  "selectAll": "Tout sélectionner",
  "all": "Tous",
  "selected": "sélectionnés",
  "menu": {
    "streams": "Flux de données",
    "extracts": "Extraits",
    "aggregates": "Agrégats",
    "audiences": "Audiences",
    "zones": "Zones",
    "aws_credentials": "Accès AWS",
    "rights": "Tous droits réservés.",
    "organisation": "Paramètres",
    "api": "API",
    "data_vendors": "Partenaires",
    "data_products": "Flux et Extraction",
    "users": "Utilisateurs",
    "dmps": "DMPs",
    "privacy": "Vie privée",
    "awsCredentials": "Credentials AWS",
    "pakito": "Pakito",
    "publishers": "Editeurs",
    "devices": "Devices",
    "dashboard": "Dashboard",
    "apps": "Apps",
    "sdk": "Sdk",
    "motion_models": "Motion models",
    "sdk_documentation": "Documentation",
    "sdk_configuration": "Configuration",
    "sdk_credentials": "Credentials",
    "cmp": "Cmp",
    "cmp_configuration": "Configuration",
    "cmp_analytics": "Analytics",
    "cmp_consent_request_layouts": "Layout",
    "remote_parameter": "Paramètres à distance",
    "finance": "Finance",
    "dev": "Outil de dév",
    "geocode_tools": "Outil de géocodage",
    "page_elements": "Edition de contenu",
    "services": "Services",
    "applications": "Applications",
    "industries": "Industries"
  },
  "table": {
    "elementsCount": "Affichage de {{firstElement}} à {{lastElement}} sur {{totalElements}} éléments",
    "show": "Afficher",
    "entries": "éléments",
    "search": "rechercher"
  },
  "users": {
    "tabName": "Utilisateurs",
    "tableName": "Utilisateurs",
    "new": "Nouvel utilisateur",
    "firstName": "Prénom",
    "lastName": "Nom",
    "email": "Email",
    "company": "Société",
    "lastConnection": "Dernière connexion",
    "createdAt": "Date de création",
    "role": "Role",
    "phoneNumber": "Numéro de téléphone mobile",
    "missingPhone": "Cet utilisateur n'a pas de numéro de téléphone",
    "roles": "Roles",
    "impersonate": "Imiter",
    "subscribedToSdkVersionNewsletter": "Abonné à la newsletter de la nouvelle version ?"
  },
  "privacy": {
    "tabName": "Vie privée",
    "general": "General",
    "isIab": "Etes-vous membre du TCF ?",
    "selectVendor": "Sélectionnez votre entité",
    "purposes": "Finalités",
    "purpose": "Finalité",
    "specialFeature": "Foncionnalité Spéciale",
    "privacyPolicy": "URL de la politique de confidentialité",
    "geomedia": "Utilisation des données à des fins publicitaires",
    "geodata": "Utilisation des données à des fins d'analyses"
  },
  "awsCredentials": {
    "tabName": "Credentials AWS",
    "creds": "Identifiant AWS",
    "general": "liste d'identifiant",
    "new": "Ajouter identifiant AWS",
    "delete_value": "supprimez moi",
    "deletePlaceholder": "Tappez \"Supprimer\" pour supprimer",
    "createAlert": {
      "title": "Action impossible",
      "text": "Vous ne pouvez pas avoir plus de deux credentials actifs en même temps"
    },
    "validation_message": "Pour supprimer tapez dans le champ suivant"
  },
  "devices": {
    "tabName": "Devices",
    "id": "Id",
    "idfa": "MAID",
    "app": "App",
    "active": "Active",
    "enable": "Enabled",
    "createdAt": "Created at",
    "updatedAt": "Updated at",
    "InactivatedAt": "Inactivated at",
    "lastRequest": "Last request",
    "appVersion": "App version",
    "sdkVersion": "SDK version",
    "locationStatus": "Location status",
    "locationAutorized": "Location authorized",
    "locationMode": "Location mode",
    "deviceModel": "Device model",
    "systemVersion": "System version",
    "lang": "Language",
    "backgroundLocationEnabled": "Background location enabled",
    "adTracking": "Ad tracking",
    "cmp": "Cmp",
    "isCmp": "Is cmp",
    "cmpMode": "Cmp mode",
    "sptVendorConsent": "Singlespot vendor consent",
    "geomediaConsent": "Geomedia consent",
    "geoDataConsent": "Geodata Consent",
    "iabConsentString": "IAB consent string",
    "addToMonitored": "Monitorer",
    "remoteParams": "Remote parameters",
    "general": "General",
    "EnabledHistory": "Enabled history",
    "LocationStatusHistory": "Locations status history",
    "LocationAuthorizedHistory": "Location authorized history",
    "SptVendorConsentHistory": "Singlespot vendor consent history",
    "MediaConsentHistory": "Media consent history",
    "DataConsentHistory": "Data consent history",
    "version": "Version",
    "requests": "Requests",
    "monitored": "Monitoré",
    "editToMonitored": "Éditer la description",
    "trackedApps": "Applications suivies",
    "apps": "Applications"
  },
  "geography": {
    "tabName": "Filtres géographiques"
  },
  "analytics": {
    "tabName": "Analytics",
    "dataByDay": "Données par jour",
    "table": {
      "events": "Events D-1",
      "daily_users": "Daily users D-1",
      "events_per_user": "Events per user D-1",
      "monthly_users": "MAU",
      "mtd_users": "MTD users",
      "avg_daily_users": "Avg DAU"
    }
  },
  "consent": {
    "tabName": "Consentement"
  },
  "app": {
    "tabName": "Applications",
    "app_version": "Version d'app",
    "sdk_version": "Version du sdk",
    "sdk_versions": "Versions du sdk",
    "environment": "Environnement",
    "test_date": "Date de test",
    "production_date": "Date de production",
    "cmp_approved": "CMP approuvée",
    "cmp_name": "CMP",
    "isCmp": "est CMP ?",
    "testedAt": "Date de test",
    "productionAt": "Date de production",
    "actions": {
      "cmp_analytics": "Analytics CMP",
      "admin": "Admin",
      "cmp_configuration": "Configuration CMP"
    },
    "is_cmp": "CMP Singlespot",
    "cmp_approved_at": "CMP approuvée le",
    "general": {
      "general": "General",
      "sdk_version": "Version SDK",
      "app_version": "Version de l'app",
      "cmp_approval": "Approbation CMP"
    },
    "cmp_approved_by": "CMP approuvée par",
    "test_sdk_date": "Date de test de la version",
    "test_sdk_version": "Version du SDK en test",
    "prod_sdk_date": "Date de production de la version",
    "prod_sdk_version": "Version du SDK en production",
    "test_app_date": "Date de test de la version",
    "prod_app_version": "Version de l'app en production",
    "test_app_version": "Version de l'app en test",
    "prod_app_date": "Date de production de la version",
    "tracked": "Suivi des requêtes",
    "cmp_approved_app_version": "Version de la CMP concernée",
    "cmp_approved_and_above": "Appliquer aussi aux versions postérieures",
    "created_at": "Date de création",
    "remoteConfiguration": {
      "WithABGroup": "ajouter un déploiement A/B",
      "ABRatioTitle": "Pourcentage",
      "ABRatioPlaceholder": "Taux de déploiement A/B",
      "ABDeploy": "Déploiement A/B"
    },
    "deletePlaceholder": "Confirmez en tapant, \"confirmer la suppression\"",
    "confirm": "confirmer la suppression"
  },
  "sdk": {
    "tabName": "SDK"
  },
  "layout": {
    "tabName": "Layout"
  },
  "vendor": {
    "tabName": "Vendeurs"
  },
  "dataVendor": {
    "new": "Nouveau partenaire",
    "name": "Nom",
    "bucket": "Bucket",
    "cmp_vendor": "CMP Vendor",
    "cmp_vendor_id": "CMP Vendor",
    "publisher_id": "Editeur",
    "industry": "Industrie",
    "industry_id": "Industrie",
    "environment": "Environnement",
    "billing_start_date": "Date de début de facturation",
    "contact_email": "Email de contact",
    "contact_phone_number": "Numéro de téléphone",
    "publishers": "Editeurs",
    "whitelisted_publisher": "Limité aux éditeurs",
    "blacklisted_publisher": "Exclure les éditeurs",
    "blacklist": "Strategie",
    "exclude": "Exclure",
    "only": "Uniquement",
    "index": "Partenaires",
    "cpm": "Facturation",
    "general": "Générale",
    "stream": "Flux de données",
    "extractions": "Extractions",
    "vendorPublisherMissing": "Un vendeur ou un editeur doit être choisit",
    "vendorBlackList": "Vous devez choisir une strategie avec une limit d'editeur",
    "isPublisher": "Le partenaire est un éditeur",
    "selectPublisher": "Sélectionner l'éditeur",
    "publisherScope": "Périmètre éditeurs",
    "hasPublisherScope": "Limiter les éditeurs",
    "max_users": "Utilisateurs facturés maximum",
    "billingModel": "Modèle de facturation",
    "flat_fee": "Montant",
    "privacy": "Privacy",
    "contact": "Contact",
    "billing": "Facturation",
    "emptySection": "Cette section est vide",
    "reset_creds": "Reset AWS Creds",
    "users": "Utilisateurs",
    "wifiNetwork": "Réseaux Wi-Fi",
    "terminated_at": "Terminé le",
    "withOptOut": "Avec opt-out ?",
    "optOut": "Opt-out",
    "dataVendor": {
      "delete_with_extracts_warning": "Ce partenaire possède des fichiers d'extraction existants dans {{s3_prefixes}}, les supprimer entraînera également leur suppression"
    }
  },
  "streams": {
    "tabName": "Flux de données"
  },
  "stream": {
    "tabName": "Stream",
    "api": {
      "title": "API",
      "environment": "Environnement"
    },
    "new": "Nouveau flux",
    "name": "Nom",
    "general": "Informations générales",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "nameText": "Si ce champ est vide, votre flux s'appellera 'Default' et sera placé à la racine de votre bucket. Vous ne pouvez avoir qu'un seul flux 'Default'.",
    "endDateText": "La date de fin n'est pas obligatoire, dans ce cas votre stream sera actif indéfiniment.",
    "device": "Devices",
    "idfaRequired": "IDFA ou GAID requis",
    "now": "Maintenant",
    "startDateText": "Si ce champ est vide, votre flux démarrera dès que vous l'aurez activé.",
    "backgroundRequired": "Filtrer les devices qui envoient moins de données",
    "backgroundRequiredText": "Si oui, nous enlèverons de votre stream les devices qui envoient le moins de données.",
    "os": "Systèmes d'exploitation",
    "anyOs": "iOS & Android",
    "homeRequired": "Seulement les devices avec un domicile",
    "workRequired": "Seulement les devices avec un lieu de travail",
    "consent": "Consentement",
    "dataTypes": "Types de données",
    "virtual": "Virtuel",
    "geography": {
      "blockTitle": "Filtres géographiques",
      "allEventsSection": "Evènements",
      "homeSection": "Domicile",
      "workSection": "Travail",
      "filter": "Appliquer un filtre géographique",
      "useExistingZone": "Utiliser une zone existante ou créer une nouvelle zone",
      "homeFilter": "Appliquer un filtre géographique au domicile des devices",
      "workFilter": "Appliquer un filtre géographique au lieu de travail des devices",
      "zones": "Choisissez vos zones",
      "useExisting": "Utiliser une zone existante",
      "createNewZone": "Créer une nouvelle zone",
      "trace_filter_type": {
        "start": "Début",
        "end": "Fin",
        "startorend": "Début ou fin",
        "intersect": "N'importe où"
      },
      "trace_filter_type_text": "Pour les traces uniquement"
    },
    "publisherFilter": {
      "global": "Éditeurs filtrés globalement",
      "globalByPass": "Contourner le filtre d'éditeur global",
      "industry": "Filtre d'éditeur au niveau de l'industrie",
      "vendor": "Éditeurs filtrés au niveau du partenaire",
      "productFilter": "Utiliser un filtre éditeur spécifique pour ce flux",
      "dataProduct": "Filtre de flux spécifique"
    },
    "column_mapping": {
      "title": "Mappage de colonnes"
    },
    "field_filter": {
      "wysiwyg": "Guidé",
      "raw": "Raw",
      "property": "Propriété",
      "forbidden_values": "Valeurs interdites",
      "regex": "Utiliser une expression régulière",
      "forbid_null": "Interdire la valeur nulle",
      "accepted_values": "Valeurs acceptées",
      "negate": "Ne correspond pas",
      "not_negate": "Correspondant à",
      "matching": "Comportement"
    }
  },
  "publisherFilter": {
    "tabName": "Filtres éditeurs"
  },
  "extracts": {
    "tabName": "extractions"
  },
  "audiences": {
    "tabName": "audiences"
  },
  "extract": {
    "tabName": "extract",
    "new": "Nouvel extrait",
    "name": "Nom",
    "general": "Informations générales",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "nameText": "Si ce champ est vide, votre flux s'appellera 'Default' et sera placé à la racine de votre bucket. Vous ne pouvez avoir qu'un seul flux 'Default'.",
    "endDateText": "La date de fin n'est pas obligatoire, dans ce cas votre extract sera actif indéfiniment.",
    "device": "Devices",
    "idfaRequired": "IDFA ou GAID requis",
    "now": "Maintenant",
    "startDateText": "Si ce champ est vide, votre flux démarrera dès que vous l'aurez activé.",
    "backgroundRequired": "Filtrer les devices qui envoient moins de données",
    "backgroundRequiredText": "Si oui, nous enlèverons de votre extract les devices qui envoient le moins de données.",
    "os": "Systèmes d'exploitation",
    "anyOs": "iOS & Android",
    "homeRequired": "Seulement les devices avec un domicile",
    "workRequired": "Seulement les devices avec un lieu de travail",
    "consent": "Consentement",
    "dataTypes": "Types de données",
    "virtual": "Virtuel",
    "monitor": "Suivi",
    "run": "Lancer",
    "geography": {
      "blockTitle": "Filtres géographiques",
      "allEventsSection": "Evènements",
      "homeSection": "Domicile",
      "workSection": "Travail",
      "filter": "Appliquer un filtre géographique",
      "useExistingZone": "Utiliser une zone existante ou créer une nouvelle zone",
      "homeFilter": "Appliquer un filtre géographique au domicile des devices",
      "workFilter": "Appliquer un filtre géographique au lieu de travail des devices",
      "zones": "Choisissez vos zones",
      "useExisting": "Utiliser une zone existante",
      "createNewZone": "Créer une nouvelle zone",
      "trace_filter_type": {
        "start": "Début",
        "end": "Fin",
        "startorend": "Début ou fin",
        "intersect": "N'importe où"
      },
      "trace_filter_type_text": "Pour les traces uniquement"
    }
  },
  "extract_monitor": {
    "tabName": "monitor"
  },
  "information": {
    "tabName": "Informations"
  },
  "zone": {
    "new": "Nouvelle zone",
    "general": "Informations générales",
    "save": "Souhaitez-vous sauvegarder cette zone indépendamment de ce stream ?",
    "name": "Nom",
    "filterType": "Type",
    "adminBoundaries": "Frontières administratives (pays, regions, communes, ...)",
    "country": "Pays",
    "region": "Regions",
    "department": "Départements",
    "postcode": "Villes / codes postaux",
    "iris": "IRIS (2019)",
    "geojson": "Geojson",
    "coordinates": {
      "title": "Coordonnées",
      "noData": "You've got no data yet, click on the button below or drag a file here",
      "defaultRadius": "Rayon par défaut",
      "defaultRadiusText": "en mètres",
      "radiusText": "en mètres - si laissé vide, le rayon par défaut s'appliquera",
      "key": "Identifiant",
      "keyText": "Peut être un nombre ou une chaîne de caractères",
      "add": "Ajouter une coordonnée",
      "edit": "Modifier une coordonnée",
      "importTitle": "Importer depuis un fichier",
      "importDescription": "Déposer un fichier ou cliquez pour sélectionner. *.csv uniquement",
      "hasHeader": "Ce fichier contient-il une ligne d'en-tête ?",
      "columnSelection": "Choisissez quelle colonne correspond à quel attribut"
    }
  },
  "aggregate": {
    "tabName": "Aggrégation",
    "group_by": "Grouper par",
    "useAggregate": "Aggréger",
    "metrics": "Métriques",
    "spt_id_count": "Nombre de devices",
    "events_count": "Nombre d'évènements",
    "id": "Identifiant"
  },
  "delete_confirmation": "Voulez vous vraiement supprimer?",
  "admin": {
    "tabName": "Admin"
  },
  "custom_filter": {
    "title": "Filtre personalisé",
    "name": "Nom",
    "type": "Type",
    "params": "Contenu",
    "add": "Ajouter un filtre custom"
  },
  "billing": {
    "flat": "Forfait",
    "cpm": "CPM",
    "cpm_range": "CPM à paliers",
    "model": "Modèle"
  },
  "audience_scope": {
    "tabName": "Limite par audience",
    "audiences": "Audiences",
    "audience": "Audience",
    "placeholder": "Choisir une audience",
    "exclusion": "Audience à exclure?"
  },
  "audience": {
    "tabName": "Audience",
    "new": "Nouvelle audience"
  },
  "toast": {
    "created": "Ressource créée",
    "updated": "Ressource mise à jour",
    "deleted": "Ressource supprimée",
    "sync": "Synchroniser",
    "credentialsSent": "Credentials envoyés",
    "unauthorized": "Non autorisé",
    "run": "En cours d'exécution",
    "pushed": "Push effectué"
  },
  "dataByDay": {
    "title": "Données par jour",
    "devices": "Devices",
    "geolocatedDevices": "Devices geolocalisés",
    "geolocatedDevicesConsented": "Appareils geolocalisés consentis",
    "optIn": "Opt-in géolocalisation",
    "consent": "Devices avec consentement",
    "globalOptIn": "Opt-in cumulé",
    "consented_devices": "Devices avec consentement",
    "loc_consented_devices": "Devices géolocalisés avec consentement",
    "geolocated_devices_consented": "Consentement devices géolocalisés",
    "newDevices": "Nouveaux devices"
  },
  "user": {
    "guest": "Invité",
    "member": "Membre",
    "admin": "Admin"
  },
  "dataVendors": {
    "send_aws": "Générer des creds"
  },
  "publisher": {
    "new": "Nouvel Editeur",
    "name": "Nom",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "devices": "Devices",
    "optIn": "Opt-in",
    "authorizedGeoloc": "Geolocalisations autorisées",
    "consent": "Consentement",
    "consentCount": "Consentements",
    "deviceByOs": "Devices par os",
    "geolocatedDeviceByOs": "Devices geolocalisés par os",
    "locationOptInByOs": "Opt-in géolocalisation par os",
    "app": {
      "tabName": "Applications",
      "name": "Nom",
      "os": "Os",
      "environment": "Environnement",
      "production_sdk": "Production SDK",
      "test_sdk": "Test SDK",
      "cmp": "CMP",
      "title": "Applications",
      "locations": "Locations J-1",
      "locations_uu": "Locations DAU",
      "locations_uu_30_days": "Locations MAU",
      "consent": "Consentement",
      "consent_rate": "Taux de consentement"
    },
    "beacon_mode": "Mode beacon",
    "credential": "Identifiants",
    "cmp_configuration": "Configuration CMP",
    "cmp_analytics": "Statistiques CMP",
    "sdk_configuration": "Configuration SDK",
    "sdk_idfa": "SDK IDFA",
    "remote_param": "SDK paramètres distant",
    "revenues": "Revenus",
    "users": "Utilisateurs",
    "admin": "Admin",
    "status": "Statut",
    "test_date": "Date de test",
    "id": "Id",
    "created_at": "Créé le",
    "production_date": "Date de production",
    "cmp_access": "Accès à la configuration CMP?",
    "has_devices_view": "Peux voir les devices",
    "rev_sharing": "Revenue sharing",
    "cpm": "CPM",
    "billing_entity": "Entité de facturation",
    "billing_manager": "Responsable facturation",
    "model": "Modèle de facturation",
    "monthly_mrg": "MRG mensuel",
    "billing_address": "Adresse de facturation",
    "cpm_equivalent": "Equivalent CPM",
    "daily_data": "Données quotidiennes",
    "cpmValueInvalid": "Valeur invalide",
    "cpmToValidation": "Doit être supérieur à \"De\"",
    "enabled": "Activé ?",
    "default_beacon_mode": "Mode beacon par defaut",
    "can_configure_cmp": "Configuration CMP disponible",
    "rev_share": "Revenue sharing",
    "production_threshold": "Seuil de production",
    "location_status": "Statut de la géolocalisation",
    "maus_by_location_status": "MAU par statut de la géolocalisation",
    "vendorConsent": "Consentement Vendeur",
    "consentAllDevices": "Consentement tous devices",
    "location_authorized_devices": "Consentement devices geolocalisés",
    "vendorConsentByOs": "Consentement vendeur par os",
    "optInPerOs": "Consentement tous devices par os",
    "optInLocalisationPerOs": "Consentement devices geolocalisés par os",
    "environment": "Environnement",
    "actions": {
      "credentials": "Identifiants",
      "cmp_configuration": "Configuration CMP",
      "cmp_analytics": "Analytics CMP",
      "sdk_configuration": "Configuration du SDK",
      "sdk_idfa": "Configuration demande d'IDFA du SDK",
      "remote_params": "Paramètres distants du SDK",
      "revenues": "Revenus",
      "users": "Utilisateurs",
      "admin": "Admin",
      "configuration": "Configuration"
    },
    "general": {
      "tabName": "Général",
      "general": "Informations Générales",
      "billing": "Facturation",
      "exclusiveDevices": "Devices exclusifs"
    },
    "apps": {
      "tabName": "Applications"
    },
    "dataByDay": {
      "newDevices": "Nouvel appareil",
      "devices": "Appareil",
      "geolocatedDevices": "Appareil géolocalisé",
      "optIn": "OptIn"
    },
    "is_terminated": "Est terminé?",
    "terminated_at": "Terminé le"
  },
  "stats": {
    "devices": "Appareils actifs",
    "geolocated_devices": "Appareils géolocalisés",
    "opt_in_geolocated_devices": "Opt-in geoloc",
    "consent": "Consentement",
    "consent_rate": "Consentement (%)",
    "prev_locations_uu": "Localisations J-1",
    "locations_dau": "Localisations DAU",
    "locations_uu_30": "Localisations MAU",
    "acitve": "Actif",
    "inactive": "Inactif",
    "background_location_enabled": "Loacalisation en arrière-plan activé"
  },
  "locationRequestConfig": {
    "tabName": "Demande de géolocalisation",
    "config": "Configuration",
    "default_config": "Configuration par défault",
    "inherited": "hérité",
    "askIfNoConsent": "Demander l'identifiant publicitaire en l'absence de consentement",
    "iosAskMode": "Modalité de demande de la géolocalisation",
    "askMinDays": "Nombre de jours minimum avant d'afficher la première demande d'identifiant publicitaire",
    "askMinLaunches": "Nombre de lancements minimum avant d'afficher la première demande d'identifiant publicitaire",
    "numberMaxRetry": "Nombre maximum de tentatives après un premier refus",
    "popupOnlyForRetry": "Afficher la popup du SDK seulement en cas de refus de l'alert système.",
    "usePopup": "Afficher une popup avant la demande système d'idfa",
    "retryMinDays": "Nombre de jours minimum entre deux demandes d'identifiant publicitaire",
    "retryMinDaysSettings": "Nombre de jours minimum entre deux demandes d'identifiant publicitaire si la popup système a déjà été refusée",
    "retryMinLaunches": "Nombre de lancements minimum entre deux demandes d'identifiant publicitaire",
    "retryMinLaunchesSettings": "Nombre de lancements minimum entre deux demandes d'identifiant publicitaire si la popup système a déjà été refusée"
  },
  "idfaRequestConfig": {
    "tabName": "Demande d'IDFA (iOS)",
    "config": "Configuration",
    "default_config": "Configuration par défault",
    "inherited": "hérité",
    "askIfNoConsent": {
      "title": "Demander l'identifiant publicitaire en l'absence de consentement",
      "tooltip": "Indique si vous souhaitez demander l'accès à l'identifiant publicitaire même en l'absence de consentement pour les finalités associées; <br/><br/> Si seul Singlespot utilise l'identifiant publicitaire, vous pouvez choisir 'Non', mais si tout autre service de votre application l'utilise, vous devez alors laisser la valeur par défaut 'Oui'. <br/><br/> Cette valeur n'est utilisée que si vous avez initialisé le SDK avec IDFARequestMode 'serverBased'."
    },
    "askMinDays": {
      "title": "Nombre de jours minimum avant d'afficher la première demande d'identifiant publicitaire",
      "tooltip": "Par exemple, si vous choisissez '2', la demande d'identifiant publicitaire ne sera affichée qu'au moins 2 jours après le premier lancement de l'application. <br/><br/> Si vous souhaitez l'afficher dès le premier lancement, entrez la valeur '0'. <br/><br/> En cas de conflit avec le nombre de lancements minimum entré ci-dessous, c'est le premier seuil atteint qui sera pris en compte. <br/><br/> Cette valeur n'est utilisée que si vous avez initialisé le SDK avec IDFARequestMode 'serverBased'."
    },
    "askMinLaunches": {
      "title": "Nombre de lancements minimum avant d'afficher la première demande d'identifiant publicitaire",
      "tooltip": "Par exemple, si vous choisissez '2', la demande d'identifiant publicitaire ne sera pas affichée lors des 2 premiers lancements, et sera donc affichée au 3e lancement de l'application. <br/><br/> Si vous souhaitez l'afficher dès le premier lancement, entrez la valeur '0'. <br/><br/> En cas de conflit avec le nombre de jours minimum entré ci-dessus, c'est le premier seuil atteint qui sera pris en compte. <br/><br/> Cette valeur n'est utilisée que si vous avez initialisé le SDK avec IDFARequestMode 'serverBased'."
    },
    "numberMaxRetry": {
      "title": "Nombre maximum de tentatives après un premier refus",
      "tooltip": "Par exemple, si vous choisissez '0', la popup sera affichée une seule fois lors de la première demande, mais pas de nouvelle tentative ultérieure en cas de refus. <br/><br/> Si vous choisissez '1', la popup pourra être affichée deux fois : lors de la première demande, et une nouvelle fois en cas de refus."
    },
    "popupOnlyForRetry": {
      "title": "Afficher la popup du SDK seulement en cas de refus de l'alert système.",
      "tooltip": "En cas de refus de l'alert système, vous permeet de présenter une popup redirige vers les settings de l'app"
    },
    "usePopup": {
      "title": "Afficher une popup avant la demande système d'idfa",
      "tooltip": "Vous permet d'afficher une popup avant les demandes de localisation du système,  permettant à vos utilisateurs de bien comprendre la demande de localisation  qui va suivre et ainsi améliorer les taux d'opt-in."
    },
    "retryMinDays": {
      "title": "Nombre de jours minimum entre deux demandes d'identifiant publicitaire",
      "tooltip": "Par exemple, si vous choisissez '2', une nouvelle demande d'identifiant publicitaire sera affichée au moins 2 jours après la précédente. <br/><br/> La valeur minimum autorisée est '1'. <br/><br/> En cas de conflit avec le nombre de lancements minimum entré ci-dessous, c'est le premier seuil atteint qui sera pris en compte."
    },
    "retryMinDaysSettings": {
      "title": "Nombre de jours minimum entre deux demandes d'identifiant publicitaire si la popup système a déjà été refusée",
      "tooltip": "Idem nombre de jours minimum ci-dessus, mais dans le cas où la demande d'identifiant publicitaire système a déjà été présentée et refusée. <br/><br/> Si l'utilisateur accepte cette popup, il sera redirigé vers les réglages systèmes de votre application afin d'y activer son identifiant publicitaire."
    },
    "retryMinLaunches": {
      "title": "Nombre de lancements minimum entre deux demandes d'identifiant publicitaire",
      "tooltip": "Par exemple, si vous choisissez '2', une nouvelle demande d'identifiant publicitaire sera affichée 2 lancements après la précédente. <br/><br/> La valeur minimum autorisée est '1'. <br/><br/> En cas de conflit avec le nombre de jours minimum entré ci-dessus, c'est le premier seuil atteint qui sera pris en compte."
    },
    "retryMinLaunchesSettings": {
      "title": "Nombre de lancements minimum entre deux demandes d'identifiant publicitaire si la popup système a déjà été refusée",
      "tooltip": "Idem nombre de lancements minimum ci-dessus, mais dans le cas où la demande d'identifiant publicitaire système a déjà été présentée et refusée. <br/><br/> Si l'utilisateur accepte cette popup, il sera redirigé vers les réglages systèmes de votre application afin d'y activer son identifiant publicitaire."
    }
  },
  "enabled": "Activé",
  "disabled": "Desactivé",
  "general": {
    "tabName": "Général"
  },
  "version": {
    "tabName": "Versions",
    "device_per_sdk_version": "Devices par version de SDK ",
    "device_per_os_version": "Devices par version d'OS",
    "device_per_app_version": "Devices par version de l'app",
    "device_per_sdk_version_evolution": "Evolution des devices par version de SDK",
    "device_per_os_version_evolution": "Evolution des devices par version d'OS",
    "device_per_app_version_evolution": "Evolution des devices par version d'app",
    "location_status_per_os_version": "Statut de la géolocalisation par version d'OS"
  },
  "apps": {
    "tabName": "Apps"
  },
  "creds": {
    "api_key": "API Key",
    "secret": "Secret"
  },
  "fr": {
    "tabName": "Français"
  },
  "en": {
    "tabName": "Anglais"
  },
  "pageElement": {
    "index": "Contenus",
    "name": "Nom",
    "label": "Label",
    "translate": "Traductions"
  },
  "requests": {
    "tabName": "Requests"
  },
  "map": {
    "tabName": "Carte"
  },
  "monitoredDevice": {
    "editTitle": "Ajouter une description au device",
    "description": "Description",
    "user": "Utilisateur"
  },
  "sdkDoc": {
    "android": {
      "tabName": "android"
    },
    "ios": {
      "tabName": "iOS"
    },
    "cordova": {
      "tabName": "Cordova"
    },
    "reactNative": {
      "tabName": "React Native"
    },
    "tcfv2Migration": {
      "tabName": "Migration TCF v2"
    },
    "unity": {
      "tabName": "Unity"
    },
    "flutter": {
      "tabName": "Flutter"
    }
  },
  "cmp": {
    "popup": {
      "tabName": "Popup",
      "configBlockTitle": "Infos générales",
      "publisherName": "Nom de l'entité qui récolte les consentements",
      "privacyPolicyUrl": "URL de la politique de confidentialité",
      "dpoEmail": "Email du DPO",
      "dpoPostalAddress": "Adresse postale complète du DPO",
      "languages": "Langues",
      "defaultLanguage": "Langue par défaut",
      "allowRetry": "Autoriser de nouvelles tentatives",
      "optinValidity": "Durée de validité du consentement (en mois)",
      "includeAllIabVendors": "Inclure tous les vendeurs IAB",
      "contentBlockTitle": "Contenu",
      "layoutBlockTitle": "Apparence",
      "general": "General",
      "dpoContact": "Contact du DPO",
      "retry": "Retry",
      "linkColor": "Couleur des liens",
      "buttonColor": "Couleur des boutons",
      "activeSwitchColor": "Couleur des switchs",
      "headerColor": "Couleur de l'arrière-plan du logo",
      "backgroundColor": "Couleur d'arrière-plan",
      "textColor": "Couleur du texte",
      "fontUrl": "Lien CDN du fichier CSS chargeant la police d'écriture",
      "fontUrlText": "Fichier CSS contenant les @font-face en font-weight 400 et 700 (normal et bold)",
      "fontSelector": "Selecteur de la police d'écriture",
      "fontSelectorText": "Roboto pour la font Roboto par exemple. En cas d'échec : Helvetica, Arial, sans-serif",
      "defaultTcfV2ConsentRequestLayoutVersion": "Version du layout",
      "logo": "Logo",
      "logoText": "Format autorisé : .png",
      "headImageBuffer": "Buffer de l'image d'en-tête"
    },
    "vendors": {
      "tabName": "Vendors",
      "addVendor": "Ajouter un vendor",
      "selectVendor": "Choisissez un vendor",
      "createVendor": "Créer un nouveau vendor",
      "name": "Nom du vendeur",
      "policyUrl": "URL de la politique de confidentialité",
      "key": "Clé",
      "purposes": "Finalités"
    },
    "purposes": {
      "tabName": "Finalités",
      "addPurpose": "Ajouter une finalité"
    },
    "apps": {
      "tabName": "Applications",
      "addAppGroup": "Nouveau groupe d'applications"
    },
    "appGroups": {
      "name": "Nom",
      "bundleIdMatchers": "Bundle IDs",
      "isDefault": "Groupe par défaut",
      "os": "Système d'exploitation",
      "selectOs": "Choisissez un OS",
      "edit": "Modifier"
    },
    "appGroup": "Groupe d'apps",
    "purpose": "Finalité",
    "stack": "Stack",
    "special_feature": "Fonctionnalité Spéciale",
    "name": "Nom",
    "description": "Description",
    "descriptionLegal": "Description légale",
    "iabId": "ID IAB",
    "iabType": "Type IAB",
    "legIntAllowed": "Autoriser l'intérêt légitime",
    "privacyPolicyUrl": "URL de la politique de confidentialité",
    "legInt": "Intéret légitime",
    "title": "Titre",
    "body": "Corps",
    "key": "Clé",
    "preview": {
      "output": "Output",
      "action": "Action :",
      "iabString": "IAB Consent String :",
      "singlespot": "Singlespot",
      "iab": "IAB",
      "purposes": "Finalités",
      "vendors": "Vendeurs",
      "nothingToDisplay": "Aucun élément à afficher",
      "allowedPurposeIds": "IDs des finalités autorisées :",
      "allowedVendorIds": "IDs des vendeurs autorisés :",
      "specialFeatureIds": "IDs des fonctionnalités spéciales autorisées :",
      "legIntPurposeIds": "IDs des finalités autorisées pour l'intérêt légitime :",
      "onAccept": "Tout accepter",
      "onRefuse": "Tout refuser",
      "onSave": "Enregistrer",
      "onCancel": "Annuler"
    },
    "consentRequestLayouts": "Templates de consentement",
    "analytics": {
      "kpis": {
        "displayRate": "Affiché",
        "consentRate": "Consentement",
        "devices": "Devices",
        "consentedDevices": "Consentements obtenus",
        "devicesWithCmpPresented": "Consentements demandés"
      },
      "dataByDay": {
        "title": "Données par jour",
        "daily": "quotidien",
        "cumulated": "cumulé",
        "table": "Table"
      },
      "metrics": {
        "devices": "Devices",
        "devicesWithCmpPresented": "Consentements demandés",
        "presentationRate": "Taux de présentation",
        "consentedDevices": "Consentements",
        "consentRate": "Taux de consentement",
        "dailyCmpPresented": "Consentements demandés (par jour)",
        "dailyConsents": "Consentements (par jour)",
        "dailyConsentRate": "Taux de consentement (par jour)",
        "dailyAverageDisplayRank": "Rang de présentation moyen (par jour)",
        "productionDate": "Date de production",
        "testDate": "Date de test",
        "name": "Nom",
        "productionSdk": "Production SDK",
        "testSdk": "Test SDK",
        "environment": "Environnement",
        "averageDisplayRank": "Rang de présentation",
        "iabId": "ID IAB"
      },
      "tcfVersion": "Version du TCF",
      "accept": "Accepter",
      "deny": "Refuser",
      "save": "Enregistrer",
      "consentsByOutput": "Output (1e présentation)",
      "consentsByOs": "Consentement par OS",
      "consentRequestsByLang": "Demandes de consentement par langue",
      "consentsByLang": "Consentement par langue (1e présentation)",
      "consentRequestsByRank": "Demandes de consentement par rang d'affichage",
      "consentsByRank": "Consentement par rang d'affichage",
      "consentRequestsByLayout": "Demandes de consentement par version du layout",
      "consentRequestsByLayoutByDay": "Evolution des demandes de consentement par version du layout"
    },
    "unconfigured": {
      "title": "Accès non configuré",
      "message": "Il semblerait que votre accès à la CMP ne soit pas encore configuré. Si vous souhaitez y avoir accès, contactez votre account manager afin qu'il l'active."
    }
  },
  "publisherInvoice": {
    "title": "Revenus",
    "from": "du",
    "to": "au",
    "mau": "Utilisateurs Actifs Mensuels",
    "price": "Total (HT)",
    "cpm": "CPM",
    "fixed": "Forfait",
    "prorata": "Prorata temporis",
    "mrg": "Revenu minimum garanti",
    "revshare_basis": "Assiette du revenue sharing",
    "revshare": "Taux du revenue sharing",
    "revshare_amount": "Revenue sharing",
    "details": "Détails par OS et app",
    "ios": "iOS",
    "android": "Android",
    "confirm_finalize": "Vous allez finaliser cet AAF. Êtes-vous sûr ?",
    "confirm_deletion": "Vous allez supprimer cet AAF. Êtes-vous sûr ?",
    "invoicingRequest": "AAF",
    "finalize": "Finaliser",
    "users": "Devices",
    "finalized": "AAF finalisé !",
    "mbu": "Utilisateurs Facturés Mensuels",
    "prorata_temporis": "prorata temporis"
  },
  "invoice": "Finance",
  "invoices": {
    "mrg": "MRG",
    "rev_share_amount": "Rev Share",
    "publisher_amount": "Total Editeur",
    "data_vendor_amount": "Revenus",
    "gross": "Marge brute",
    "status": "Statut",
    "amount": "Montant"
  },
  "incomes": {
    "final": "Final",
    "draft": "Draft"
  },
  "download": "Télécharger",
  "vendors": {
    "tabName": "Vendeurs"
  },
  "publishers": {
    "tabName": "Editeurs"
  },
  "dashboard": {
    "sdkVersion": "Version SDK"
  },
  "remoteConfiguration": {
    "sub": "Configuration à distance",
    "remoteParameters": "Paramètres à distance",
    "key": "CLÉ",
    "value": "VALEUR"
  },
  "defaultConfiguration": {
    "tabName": "Configuration par défaut"
  },
  "iosConfiguration": {
    "tabName": "Configuration ios"
  },
  "androidConfiguration": {
    "tabName": "Configuration andorid"
  },
  "RemoteConfiguration": {
    "title": "Configuration à distance"
  },
  "sdkVersion": {
    "version": "Version",
    "os": "Os",
    "environment": "Environment",
    "changeLog": "Change log",
    "testedAt": "Tested at",
    "productionAt": "Production at",
    "newsletter": "Newsletter SDK",
    "newsletter_send": "Newsletter envoyée"
  },
  "oauth": {
    "title": "Gestion de vos applications",
    "open": "Ouvrir la configuration",
    "popup": "Pour obtenir la configuration OAuth, assurez-vous d'autoriser la fenêtre contextuelle et cliquez sur le bouton ci-dessus.",
    "credentials": "Informations d'identification",
    "error": "Erreur : %{error}",
    "code": "code",
    "authorize": "Autoriser",
    "application_uid": "application uid",
    "secret": "secret",
    "curl_command": "Commande cURL",
    "placeholder_code": "Autoriser pour obtenir le code",
    "add": "Ajouter une application",
    "no_application": "Aucune application trouvée. \nVeuillez en ajouter une pour obtenir vos informations d'identification.",
    "documentation": "Documentation"
  },
  "dataVendorInvoice": {
    "finalized": "Finalizé"
  },
  "under_maintenance": "Cette page est en maintenance",
  "history": "Historique",
  "remoteConfigurationHistory": {
    "date": "Date",
    "key": "Key",
    "value": "Value",
    "user": "Modifié par",
    "comment": "Commentaire"
  },
  "comment": "Commentaire",
  "industries": {
    "blacklistedPublisher": "Éditeurs non autorisés",
    "form": {
      "name": "nom"
    }
  },
  "dmp": {
    "form": {
      "name": "Nom"
    },
    "audiences": "Audiences",
    "deletePlaceholder": "Écrivez \"Delete\"",
    "push": "Push",
    "pushTaxonomy": "Push Taxonomy",
    "pushSegments": "Push audiences (ids seuls)",
    "pushAll": "Push complet (taxonomie + audiences)"
  },
  "motion_model": {
    "training_at": "Entrainé le",
    "dragndrop": "Faire glisser et laisser tomber",
    "os": "Os",
    "model_file": "Fichier de modèle",
    "title": "Modèle de mouvement"
  }
}
